"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.number.constructor");
var _couponPackage = require("@/api/basic/couponPackage");
var _utils = require("@/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponPackageTab',
  data: function data() {
    return {
      loading: false,
      uploading: false,
      list: [],
      total: 0,
      activeTab: '1',
      query: {
        packageCode: '',
        packageName: '',
        isEnable: 1,
        page: 1,
        limit: 20
      },
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      imgDialog: {
        visible: false,
        row: null,
        current: ''
      }
    };
  },
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    parseTime: _utils.parseTime,
    handleTabChange: function handleTabChange() {
      this.query.isEnable = this.activeTab === '' ? undefined : Number(this.activeTab);
      this.query.page = 1;
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _couponPackage.getCouponPackagePage)(this.query).then(function (res) {
        _this.list = (res.data.records || []).map(function (r) {
          return _objectSpread(_objectSpread({}, r), {}, {
            _editing: false,
            _alias: r.packageAlias
          });
        });
        _this.total = res.data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.query = {
        packageCode: '',
        packageName: '',
        isEnable: this.activeTab === '' ? undefined : Number(this.activeTab),
        page: 1,
        limit: 20
      };
      this.fetchList();
    },
    saveAlias: function saveAlias(row) {
      var _this2 = this;
      (0, _couponPackage.updatePackageAlias)({
        id: row.id,
        packageAlias: row._alias
      }).then(function () {
        row.packageAlias = row._alias;
        row._editing = false;
        _this2.$message.success('保存成功');
      });
    },
    toggleEnable: function toggleEnable(row) {
      var _this3 = this;
      var next = row.isEnable === 1 ? 0 : 1;
      (0, _couponPackage.updatePackageEnable)({
        id: row.id,
        isEnable: next
      }).then(function () {
        row.isEnable = next;
        _this3.$message.success('操作成功');
      });
    },
    openImgUpload: function openImgUpload(row) {
      this.imgDialog = {
        visible: true,
        row: row,
        current: row.pkgImgUrl
      };
    },
    handleImgChange: function handleImgChange(e) {
      var _this4 = this;
      var file = e.target.files[0];
      if (!file) return;
      var fd = new FormData();
      fd.append('file', file);
      fd.append('path', '/couponPackage/');
      this.uploading = true;
      (0, _couponPackage.uploadImage)(fd).then(function (res) {
        var url = res.data;
        (0, _couponPackage.updatePackageImg)({
          id: _this4.imgDialog.row.id,
          pkgImgUrl: url
        }).then(function () {
          _this4.imgDialog.row.pkgImgUrl = url;
          _this4.imgDialog.current = url;
          _this4.$message.success('上传成功');
        });
      }).finally(function () {
        _this4.uploading = false;
        e.target.value = '';
      });
    }
  }
};